/** UserConfigPanel — hosts Students / Parents / Staff subtabs. Extracted from panels.jsx. */
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { StudentsPanel } from "./StudentsPanel";
import { UsersPanel } from "./UsersPanel";

export function UserConfigPanel({ students, users, schools, reload }) {
  return (
    <Tabs defaultValue="students" className="w-full">
      <TabsList className="bg-slate-100 border border-slate-200 p-1 rounded-xl h-auto" data-testid="user-config-subtabs">
        <TabsTrigger value="students" data-testid="tab-uc-students">Students</TabsTrigger>
        <TabsTrigger value="parents" data-testid="tab-uc-parents">Parents</TabsTrigger>
        <TabsTrigger value="staff" data-testid="tab-uc-staff">Staff</TabsTrigger>
      </TabsList>
      <TabsContent value="students" className="mt-4">
        <StudentsPanel students={students} users={users} schools={schools} reload={reload} />
      </TabsContent>
      <TabsContent value="parents" className="mt-4">
        <UsersPanel users={users.filter((u) => u.role === "parent")} students={students} schools={schools} reload={reload} scope="parents" />
      </TabsContent>
      <TabsContent value="staff" className="mt-4">
        <UsersPanel users={users.filter((u) => ["teacher", "school_admin", "admin"].includes(u.role))} students={students} schools={schools} reload={reload} scope="staff" />
      </TabsContent>
    </Tabs>
  );
}
